import React from 'react';

export const ShipmentIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12}
    height={12}
    fill="none"
    {...props}
  >
    <g fill="currentColor">
      <path d="m10.825 5.236-1.084-2.84c-.2-.494-.72-.824-1.285-.824H3.544c-.57 0-1.085.33-1.29.829l-1.07 2.8a1.33 1.33 0 0 0-.184.67v3.608c0 .74.605 1.343 1.344 1.343h7.312c.74 0 1.344-.604 1.344-1.343V5.87c0-.234-.065-.449-.17-.639l-.005.005ZM2.95 2.676c.085-.215.325-.355.59-.355H8.45c.27 0 .505.145.59.35l.715 1.876c-.035 0-.07-.01-.105-.01H2.339c-.035 0-.065.01-.1.01l.715-1.867-.005-.005Zm7.296 6.808c0 .33-.264.595-.594.595H2.339a.593.593 0 0 1-.594-.595V5.875c0-.06.02-.11.035-.164.01-.02.025-.03.035-.055l.04-.1a.587.587 0 0 1 .49-.275h7.31c.216 0 .396.12.5.29l.035.085s.02.03.03.05c.015.054.035.11.035.17v3.608h-.01Z" />
      <path d="M4.698 8.226h-1.48a.377.377 0 0 0-.374.375c0 .205.17.374.375.374h1.48c.204 0 .374-.17.374-.374a.377.377 0 0 0-.375-.375Z" />
    </g>
  </svg>
);
